<template>
    <div class="custom-marker-wrapper">
        <img src="/themes/custom/ef2_custom/images/marker.png" class="custom-marker" @click="handleClick" />
    </div>
</template>

<script>
import MarkerDetails from "./MarkerDetails";

export default {
    name: "MarkerWrapper",

    components: {
        'aut-marker-details': MarkerDetails
    },

    props: {
        marker: {
            type: Object,
            required: true
        },
        activeMarker: {
            type: Object
        },
        eventBus: {}
    },

    computed: {
        open() {
            return lodash.isEqual(this.activeMarker, this.marker);
        }
    },

    methods: {
        handleClick() {
            this.eventBus.$emit('location-clicked', this.marker.id);
            this.eventBus.$emit('set-map-center', this.marker.geo);
        },
    }
}
</script>

<style scoped>

</style>